import { Loader } from "@mantine/core";

interface Props {
    size?: 'sm' | 'md' | 'lg' | 'xl';
    className?: string;
}

export default function LogoLoader({ size = 'md', className = '' }: Props) {
    const logoSrc = '/images/favicon.svg';

    const sizeClasses = {
        sm: 'h-8 w-8',
        md: 'h-12 w-12',
        lg: 'h-16 w-16',
        xl: 'h-24 w-24'
    };

    return (
        <div className={`flex items-center justify-center ${className}`}>
            <div className="relative">
                {/* Pulsating shadow backdrop */}
                <div
                    className={`absolute inset-0 ${sizeClasses[size]} bg-indigo-400 rounded-full blur-xl animate-pulse`}
                    style={{
                        animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
                        opacity: 0.5
                    }}
                />
                {/* Main logo */}
                <img
                    src={logoSrc}
                    alt="Loading..."
                    className={`${sizeClasses[size]} relative z-10 animate-pulse`}
                    style={{
                        animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
                        filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1))'
                    }}
                />
            </div>
        </div>
    );
}

// Centered (a bit to the top) loader for containers
export function LoaderMainLogo({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' | 'xl' }) {
    return (
        <div className="mx-auto flex items-center justify-center p-20">
            <Loader size={size} color="black" />
        </div>
    );
}